import MicroModal from 'micromodal'
import axios from 'axios'
const prod = process.env.NODE_ENV === 'production';

export default class GeneratorCard {
    constructor(el) {
        this.el = el
        this.setVars()
        this.init()
    }
    setVars() {
        this.isModal = typeof(this.el.dataset.modal) !== 'undefined' && this.el.dataset.modal === 'true' ? this.el.dataset.modal : false
        this.modal = document.querySelector('#generator-modal')
        this.modalTarget = this.modal.querySelector('[data-modal-content-target]')
        this.url = this.el.href;
        this.resultSelector = '[data-modal-content]';
    }
    init() {
        if(this.isModal) {
            this.el.addEventListener('click', this.handleModalCardClick)
        }
    }

    handleModalCardClick = (event) => {
        event.preventDefault()
        this.handleLoadModalContent()
        console.log(event)
    }

    handleLoadModalContent = () => {
        this.modalTarget.innerHTML = '';
        axios
            .get(this.url)
            .then(({ data }) => {
                this.appendResult(data)
            })
            .catch(error => {
                if(prod) {
                    window.location = this.url
                } else {
                    console.log(error);
                }
            })
            .then(() => {
                MicroModal.show('generator-modal');
            })
    }


    appendResult = body => {
        const tempBody = document.createElement('div')
        tempBody.innerHTML = body
        const result = tempBody.querySelector(this.resultSelector)

        // Append new results
        this.modalTarget.innerHTML = '';
        this.modalTarget.appendChild(result)
    }

}
